"use client";

import BFLLink from "@repo/shared-ui/BFLLink";
import { handleHeaderRewardsClickDL } from "./HeaderAnalyticsFunction";

interface HeaderRewardsProps {
  headerRewards?: {
    ctaText?: string;
    ctaLink?: string;
  };
}

const Rewards: React.FC<HeaderRewardsProps> = ({ headerRewards }) => {
  const destinationUrl = headerRewards?.ctaLink || "";
  const ctaText = headerRewards?.ctaText || "Rewards";

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    handleHeaderRewardsClickDL(ctaText, destinationUrl);
    window.location.href = destinationUrl;
  };

  return (
    <BFLLink
      href={destinationUrl}
      aria-label={ctaText}
      onClick={handleClick}
      className="relative order-4 mx-0 my-0 flex flex-col items-center px-2 pt-[14px] pb-[30px] hover:bg-[#001326] md:order-5 md:min-h-[37px]"
    >
      <i className="icomoon text-2xl before:content-['\e963']"></i>
      <span className="hidden text-xs leading-[14px] md:!block">{ctaText}</span>
    </BFLLink>
  );
};

export default Rewards;
